import React from "react";
import { string, node } from "prop-types";

function withSuccess(Component) {
  function Wrapper({ success, children, ...props }) {
    return (
      <Component {...props}>
        {success && (
          <div data-testid="alert" className="alert alert-success w-100">
            {success}
          </div>
        )}
        {children}
      </Component>
    );
  }

  Wrapper.propTypes = {
    success: string,
    children: node
  };
  Wrapper.displayName = "withSuccess()";

  return Wrapper;
}

export default withSuccess;



// WEBPACK FOOTER //
// ./src/hoc/withSuccess.js